"use strict";

/* eslint no-console: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = void 0;

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _enviro = _interopRequireDefault(require("enviro"));

/**
 * @param {String} formUrl
 * @param {Object} data
 * @return {Promise}
 */
var submitForm = function submitForm(formUrl, data) {
  if (_enviro.default.getShort() !== 'prod') {
    console.log('Submission to pql form', formUrl, data);
  }

  return _noAuthApiClient.default.post(formUrl, {
    data: data
  });
};

exports.submitForm = submitForm;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/api/submitForm.js
// module id = 609
// module chunks = 5 6